<app-snackbar></app-snackbar>
<div class="pl-m pr-m pt-m pb-m">
	<div class="mb-s">
		<div class="disp-f a-i-c mr-s">
            <span class="font-L fw-700">{{ 'page.extension.extensionSettings' | translate }}</span>
		</div>
	</div>
	<div class="p-relative">
		<div class="text-in-illustration font-MM fw-300 white">
			<span [innerHTML]="'page.extension.ext' | translate"></span>
		</div>
		<div class="button-in-illustration disp-f a-i-c c-p prevent-select pad-0-L" (click)="openDrawerRoverTutorial()">
			<img class="filter-white" ngSrc="assets/icons/alert-circle.svg" alt="" height="25" width="25">
			<span class="ml-xs white font-M">
				{{ 'page.extension.howToDeploy' | translate }}
			</span>
		</div>
		<img class="w-100" src="/assets/illustrations/extension-settings-bg.svg" alt="Extension settings illustration">
	</div>
	<div class="hr-document mt-m mb-xl ml-xs mr-xs"></div>
	<div class="disp-f j-c-sb pl-s pr-s p-relative">
		<div class="disp-f f-d-col gap-XS">
			<span class="fw-700 font-MM">{{ 'page.extension.logo' | translate }}</span>
			<span class="font-M" [innerHTML]="'page.extension.logo.0' | translate"></span>
		</div>
		<div *ngIf="!extensionSettings || !extensionSettings.publicLogoUrl" (click)="selectFile()" (drop)="onDrop($event)" (dragover)="$event.preventDefault()" (dragleave)="$event.preventDefault()" class="add-logo-btn c-p prevent-select disp-f a-i-c j-c-c">
			<img class="filter-grey" ngSrc="assets/icons/add.svg" height="15" width="15" alt="">
		</div>
		<div *ngIf="extensionSettings && extensionSettings.publicLogoUrl" class="logo-present prevent-select disp-f a-i-c j-c-c">
			<img [src]="extensionSettings.publicLogoUrl" height="30" width="30" alt="Logo de l'organisation" class="logo-organisation">
		</div>
		<div (click)="deleteImage()" *ngIf="extensionSettings && extensionSettings.publicLogoUrl && isEditor" class="delete-image prevent-select c-p">
			<img class="filter-grey" ngSrc="assets/icons/trash.svg" height="20" width="15" alt="">
		</div>
	</div>
	<div class="hr-document mt-l mb-l ml-xs mr-xs"></div>
	<div class="disp-f j-c-sb pl-s pr-s">
		<div class="disp-f f-d-col gap-XS">
			<div class="fw-700 flex-align-center">
				<span class="font-MM">{{ 'page.extension.code.0' | translate }}</span>
			</div>
			<span class="font-M">{{ 'page.extension.code.1' | translate }}</span>
		</div>
	</div>
	<div *ngIf="extensionSettings && extensionSettings.token" class="pl-s pr-s disp-f a-i-c mt-s gap-S" style="width: calc(100% - 20px)">
		<app-copy-text style="flex-grow: 1" [text]="extensionSettings.token|| ''"></app-copy-text>
		<button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="selectMenu" [disabled]="_initializing || _loading" class="renew-button flex-center c-p" [ngClass]="{ 'renew-button-active': menuTrigger.menuOpen }">
			<img src="assets/icons/dots-vertical.svg" height="18" alt=""/>
		</button>
		<mat-menu #selectMenu class="mat-menu-custom"
				  xPosition="before" yPosition="below">
			<div (click)="onRenewClick()" class="flex-align-center gap-M greyed-hover b-radius-6 c-p" style="padding: 6px;">
				<img src="assets/icons/refresh.svg" width="18" height="18" alt="" class="filter-danger"/>
				<div class="font-M fw-500 danger">{{'page.extension.renewOption'|translate}}</div>
			</div>
		</mat-menu>
	</div>
	<div class="hr-document mt-l mb-l ml-xs mr-xs"></div>
	<div class="disp-f j-c-sb pl-s pr-s">
		<div class="disp-f f-d-col gap-XS">
			<div class="fw-700 flex-align-center">
				<span class="font-MM">{{ 'page.extension.displayExtension' | translate }}</span>
                <div class="disp-f a-i-c j-c-c" style="height: 25px; width: 25px;"
                     [tooltip]="'page.extension.formInfo.0'|translate" tooltipPosition="right">
                    <img src="assets/icons/help-2.svg" width="14" height="14" alt=""/>
                </div>
			</div>
			<span class="font-M">{{ 'page.extension.display.0' | translate }}</span>
		</div>
		<div>
			<app-toggle-button
				[toggleInput]="displayExtensionCheckFormControl"
				(change)="updateExtensionOnBlur.emit(formName.displayExtensionCheck)">
			</app-toggle-button>
		</div>
	</div>
	<div class="hr-document mt-l mb-l ml-xs mr-xs"></div>
	<div class="disp-f j-c-sb pl-s pr-s">
		<div class="disp-f f-d-col gap-XS">
			<div class="fw-700 flex-align-center">
				<span class="font-MM">{{ 'page.extension.userFeedback' | translate }}</span>
                <div class="disp-f a-i-c j-c-c" style="height: 25px; width: 25px;"
                     [tooltip]="'page.extension.formInfo.2'|translate" tooltipPosition="right">
                    <img src="assets/icons/help-2.svg" width="14" height="14" alt=""/>
                </div>
			</div>
			<span class="font-M">{{ 'page.extension.user.0' | translate }}</span>
		</div>
		<div>
			<app-toggle-button
				[toggleInput]="feedbackCheckFormControl"
				(change)="updateExtensionOnBlur.emit(formName.feedbackCheck)"></app-toggle-button>
		</div>
	</div>
	<div class="pl-s pr-s disp-f a-i-c mt-s" style="width: calc(100% - 20px)">
		<app-multi-select class="w-100" [inputControl]="feedbackFormControl">
			<app-select-trigger appearance="field">
				<span>{{ feedbackFormValue.name }}</span>
			</app-select-trigger>
			<app-select-option *ngFor="let frequency of frequencyTypeChoices" [value]="frequency">
				<span>{{ frequency.name }}</span>
			</app-select-option>
		</app-multi-select>
	</div>

	<div class="hr-document mt-l mb-l ml-xs mr-xs"></div>

	<div class="disp-f j-c-sb pl-s pr-s">
		<div class="disp-f f-d-col gap-XS">
			<div class="fw-700 flex-align-center">
				<span class="font-MM">{{ 'page.settings.agent.title' | translate }}</span>
			</div>
			<span class="w-60 font-M">{{ 'page.settings.agent.subtitle' | translate }}</span>
		</div>
		<div>
			<app-toggle-button
				[toggleInput]="applicationDisplayActivatedFormControl"
				(change)="updateExtensionOnBlur.emit(formName.applicationDisplayActivated)"></app-toggle-button>
		</div>
	</div>
	<div *ngIf="applicationDisplayActivatedFormControl.value" class="pl-s pr-s flex-column gap-M a-i-c mt-s" style="width: calc(100% - 20px)">
		<app-multi-select [width]="350" #multiSelectComponent class="w-100" [inputControl]="applicationDisplayFormControl">
			<app-select-trigger appearance="field">
				<span>{{ 'page.settings.agent.modes.' + applicationDisplayFormControl.value | translate }}</span>
			</app-select-trigger>
			<app-select-option *ngFor="let applicationDisplayType of applicationDisplayTypeChoices" [value]="applicationDisplayType">
				<span>{{ 'page.settings.agent.modes.' + applicationDisplayType | translate }}</span>
			</app-select-option>
		</app-multi-select>
		<app-text-button (click)="openApplicationList()" class="w-100" [type]="'stroked'" *ngIf="applicationDisplayFormControl.value === ExtensionApplicationDisplay.CUSTOM">
			{{ 'page.settings.agent.displayList' | translate }}
		</app-text-button>
	</div>

	<div class="hr-document mt-l mb-l ml-xs mr-xs"></div>

	<div class="disp-f j-c-sb pl-s pr-s">
		<div class="disp-f f-d-col gap-XS">
			<div class="fw-700 flex-align-center">
				<span class="font-MM">{{ 'page.extension.supportRequest' | translate }}</span>
				<div class="disp-f a-i-c j-c-c" style="height: 25px; width: 25px;"
					 [tooltip]="'page.extension.formInfo.1'|translate" tooltipPosition="right">
					<img src="assets/icons/help-2.svg" width="14" height="14" alt=""/>
				</div>
			</div>
			<span class="font-M">{{ 'page.extension.support.0' | translate }}</span>
		</div>
		<div>
			<app-toggle-button
				[toggleInput]="supportUrlCheckFormControl"
				(change)="updateExtensionOnBlur.emit(formName.supportUrlCheck)">
			</app-toggle-button>
		</div>
	</div>
	<div class="pl-s pr-s disp-f a-i-c mt-s" style="width: calc(100% + 10px)">
		<div class="text-input-prefix disp-f a-i-c j-c-c">
			https://
		</div>
		<app-text-input
			panelClass="b-radius-right-6"
			style="width: calc(100% - 90px)"
			[input]="supportUrlFormControl"
			[placeholder]="'page.appDetails.domainPlaceholder'|translate"
			(blur)="updateExtensionOnBlur.emit(formName.supportUrl)"
			(keyup.enter)="updateExtensionOnBlur.emit(formName.supportUrl)">
		</app-text-input>
	</div>

    <div *ngIf="displayTeams" class="hr-document mt-l mb-l ml-xs mr-xs"></div>
    <div *ngIf="displayTeams" class="flex-column j-c-sb pl-s pr-s">
        <div class="disp-f f-d-col gap-XS">
            <div class="fw-700 flex-align-center">
                <span class="font-MM">{{ 'Identifiants d\'équipes' | translate }}</span>
                <div class="disp-f a-i-c j-c-c" style="height: 25px; width: 25px;"
                     [tooltip]="'page.extension.formInfo.2'|translate" tooltipPosition="right">
                    <img src="assets/icons/help-2.svg" width="14" height="14" alt=""/>
                </div>
            </div>
            <span class="font-M">{{ 'Identifiants nécessaire au déploiement par outil de gestion de parc' | translate }}</span>
        </div>
        <div *ngIf="!_initializing && extensionSettings.teams.length > 0" class="team-id-table mt-m">
            <div class="team-id-header flex-align-center">Equipe</div>
            <div class="team-id-header flex-align-center">Structure</div>
            <div class="team-id-header last flex-align-center flex-space-between">
                <div>Team</div>
                <app-text-button type="default" color="primary"  style="width: 43px; height: 43px;" panelClass="h-100-imp pad-0-imp"
                                 [matMenuTriggerFor]="selectMenu">
                    <div class="flex-center">
                        <img src="assets/icons/dots-vertical.svg" height="16" alt=""/>
                    </div>
                </app-text-button>
                <mat-menu #selectMenu class="mat-menu-custom"
                          xPosition="before" yPosition="below">
                    <div class="flex-align-center gap-M greyed-hover b-radius-6 c-p" style="padding: 6px;"
                         (click)="export(type.CSV)">
                        <img src="assets/icons/share.svg" width="18" height="18" alt=""/>
                        <div class="font-M fw-500">{{'page.application.table.filters.export'|translate}}</div>
                    </div>
                    <div class="flex-align-center gap-M greyed-hover b-radius-6 c-p" style="padding: 6px;"
                         (click)="export(type.XLSX)">
                        <img src="assets/icons/layout-grid-02.svg" width="18" height="18" alt=""/>
                        <div class="font-M fw-500">{{'page.application.table.filters.exportX'|translate}}</div>
                    </div>
                </mat-menu>

            </div>
            @for (team of extensionSettings.teams; track team.teamId; let last = $last) {
                <div [class.vertical-last]="last" style="width: 100px" [tooltip]="team.path + ' > ' + team.name" class="team-id-cell text-overflow-ellipsis pad-XS">{{ team.name }}</div>
                <div [class.vertical-last]="last" class="team-id-cell">
                    <app-copy-text [setBackground]="false" [text]="team.structureId"></app-copy-text>
                </div>
                <div [class.vertical-last]="last" class="team-id-cell last">
                    <app-copy-text [setBackground]="false" [text]="team.teamId"></app-copy-text>
                </div>
            }
        </div>
        <div *ngIf="!_initializing && extensionSettings.teams.length === 0" class="mt-m bg-rounded flex-column flex-align-center flex-justify-center gap-L" style="min-height: 400px">
            <img src="assets/illustrations/no_announcement.svg" height="100" alt="no team illustration"/>
            <div class="font-M fw-500 grey">{{ 'Vous n\'avez pas encore d\'équipe. Commencez par décrire votre organisation.' | translate }}</div>
            <app-text-button (click)="rightSliderService.close()" [routerLink]="MainMenuPath.ORGANIZATION" type="stroked">{{ 'Modéliser mon organisation' | translate }}</app-text-button>
        </div>
    </div>
</div>
